export const getMeasureFromArray = (
  measureArr: [number, number, number, number]
) => {
  return measureArr.map((measure) => `${measure * 0.5}rem`).join(' ')
}
